module.exports = __webpack_public_path__ + "media/images/administrator_profile-d58e0bdae1f0e4a28ebf2ee97f7c1bbe.webp";